import styled from "styled-components";

export const ImageContainer = styled.div`
  height: 56px;
  width: 56px;
  border-radius: 50%;
`;
